import { com } from '@eidu/web'
import { useParams } from 'react-router-dom'
import { requireNotUndefinedOrNull } from '../../util/require'
import EntityTypeNotAccessibleError from './EntityTypeNotAccessibleError'
import { getKindPageConfig } from './kindViewRegistry'
import useEntity from './useEntity'
import EntityId = com.eidu.sharedlib.entity.EntityId
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import entityIdFromString = com.eidu.sharedlib.entity.entityIdFromString
import entityTypeIdFromString = com.eidu.sharedlib.entity.type.entityTypeIdFromString

type CreateOrEditPageProps = {
  entityId: EntityId | undefined
  entityTypeId: EntityTypeId
}

const CreateOrEditPage = ({ entityId, entityTypeId }: CreateOrEditPageProps) => {
  const { entityType, entityTypes, entity, loading } = useEntity({ entityTypeId, entityId })

  const EditPage = entityType ? getKindPageConfig(entityType.kind).EditPage : undefined

  const entityReady = entityId === undefined || entity !== undefined

  return (
    <>
      {entityType && entityTypes && EditPage && entityReady && (
        <EditPage
          key={entityId?.toString() ?? 'new'}
          entity={entity}
          entityId={entityId}
          entityType={entityType}
          entityTypes={entityTypes}
          loading={loading}
        />
      )}
      {!loading && (!entityType || !entityTypes || !EditPage) && <EntityTypeNotAccessibleError />}
    </>
  )
}

const CreateOrEditPageRoute = () => {
  const params = useParams()
  const entityTypeId = entityTypeIdFromString(requireNotUndefinedOrNull(params.entityTypeId))
  const entityId = params.entityId?.let(entityIdFromString)

  return <CreateOrEditPage entityTypeId={entityTypeId} entityId={entityId} />
}

export default CreateOrEditPageRoute
